module.exports = __webpack_public_path__ + "media/images/emoticons/car-d76a2bf7d7824bb471823adb00a81af9.gif";